var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVanguardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 2,
    fill: "#F8F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5895C10 12.8 12.2316 19.3263 15.0105 27.0316C17.7474 34.7368 20.4842 42.6105 21.1158 44.5474L22.2947 48H27.3053H32.3579L33.1158 46.1895C33.5368 45.2211 37.5368 37.3474 41.9579 28.6737C46.3789 20 50 12.7579 50 12.5474C50 12.3789 47.979 12.2105 45.4947 12.2105H40.9474L38.6316 17.1789C37.3684 19.8737 34.4211 26.0632 32.1053 30.8632L27.8526 39.6632L23.5579 26.4421C21.2 19.1579 19.2632 12.9684 19.2632 12.7158C19.2632 12.3368 17.9158 12.2105 14.6316 12.2105C12.0211 12.2105 10 12.3789 10 12.5895Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanguardIcon);
export default __webpack_public_path__ + "static/media/vanguard_icon.188d6ef1f02aade4696a2fee75f17a8e.svg";
export { ForwardRef as ReactComponent };